"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTotalCount = void 0;
var _EXPORTS_1 = require("./_EXPORTS");
var getTotalCount = function (_a) {
    var data = _a.data, countPath = _a.countPath;
    var total = 0;
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var d = data_1[_i];
        var count = (0, _EXPORTS_1.getVal)(d, countPath) || 0; // fallback to 0, cuz sometimes backend systems return 'undefined' if the count of data against a field is non-existent / zero
        total += count;
    }
    return total;
};
exports.getTotalCount = getTotalCount;
